import * as angular from "angular";
import {InstitutionSelectorComponent} from "./selector/institution-selector.component";
import {InstitutionService} from "./institution.service";
import {ITemplateCacheService} from "angular";

export const InstitutionModule = angular
    .module("app.shared.institution", [])

    .service("institutionService", InstitutionService)

    .component("institutionSelector", InstitutionSelectorComponent)

    .run(($templateCache: ITemplateCacheService) => {
        $templateCache.put("institution-selector-item.html", require("./selector/institution-selector-item.html"));
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/institution/institution.module.ts